module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-outline', {
    attrs: {
      "title": _vm.$t('suppliers.form_supplier_create_title'),
      "icon": "icon-sent"
    }
  }, [_c('template', {
    slot: "pageContent"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "idLabel": _vm.$t('suppliers.supplier_id'),
      "mandatoryErrorIndicator": _vm.sirenError,
      "regexpErrorIndicator": _vm.sirenRegexpError,
      "warningIndicator": _vm.controlsConfig === '1' ? _vm.administrativeState === 'F' : false,
      "specificErrorIndicator": _vm.controlsConfig === '2' ? _vm.administrativeState === 'F' : false,
      "maxLength": 9,
      "specificMessage": _vm.$t('suppliers.closed_admin_state')
    },
    model: {
      value: (_vm.siren),
      callback: function($$v) {
        _vm.siren = $$v
      },
      expression: "siren"
    }
  })], 1), _vm._v(" "), (!_vm.LMSGsupplierconfig) ? _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "idLabel": _vm.$t('common.social_reason'),
      "mandatoryErrorIndicator": _vm.socialReasonError,
      "warningIndicator": _vm.controlsConfig === '1' ? _vm.differentSocialReason : false,
      "specificErrorIndicator": _vm.controlsConfig === '2' ? _vm.differentSocialReason : false,
      "specificMessage": _vm.$t('suppliers.not_same_social_reason', {
        realSocialReason: _vm.databaseSocialReason
      })
    },
    model: {
      value: (_vm.socialReason),
      callback: function($$v) {
        _vm.socialReason = $$v
      },
      expression: "socialReason"
    }
  })], 1) : _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "idLabel": _vm.$t('filter.supplier_id'),
      "mandatoryErrorIndicator": _vm.sellerIdentifierError
    },
    model: {
      value: (_vm.sellerIdentifier),
      callback: function($$v) {
        _vm.sellerIdentifier = $$v
      },
      expression: "sellerIdentifier"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "idLabel": _vm.$t('suppliers.supplier_siret'),
      "mandatoryErrorIndicator": _vm.siretError,
      "regexpErrorIndicator": _vm.siretRegexpError,
      "warningIndicator": _vm.controlsConfig === '1' ? _vm.differentSIRET : false,
      "specificErrorIndicator": _vm.controlsConfig === '2' ? _vm.differentSIRET : false,
      "maxLength": 14,
      "specificMessage": _vm.$t('suppliers.not_same_siret', {
        realSIRET: _vm.databaseSIRET
      })
    },
    model: {
      value: (_vm.siret),
      callback: function($$v) {
        _vm.siret = $$v
      },
      expression: "siret"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.dt_crtn')
    },
    model: {
      value: (_vm.dateCreation),
      callback: function($$v) {
        _vm.dateCreation = $$v
      },
      expression: "dateCreation"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [(_vm.LMSGsupplierconfig) ? _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "idLabel": _vm.$t('common.social_reason'),
      "mandatoryErrorIndicator": _vm.socialReasonError
    },
    model: {
      value: (_vm.socialReason),
      callback: function($$v) {
        _vm.socialReason = $$v
      },
      expression: "socialReason"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "idLabel": _vm.LMSGsupplierconfig ? _vm.$t('suppliers.supplier_name') : _vm.$t('suppliers.supplier_name_2'),
      "warningIndicator": _vm.controlsConfig === '1' ? _vm.differentLastName : false,
      "specificErrorIndicator": _vm.controlsConfig === '2' ? _vm.differentLastName : false,
      "specificMessage": _vm.$t('suppliers.not_same_lastname', {
        realLastName: _vm.databaseLastName
      })
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), (!_vm.LMSGsupplierconfig) ? _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('suppliers.supplier_firstname'),
      "warningIndicator": _vm.controlsConfig === '1' ? _vm.differentFirstName : false,
      "specificErrorIndicator": _vm.controlsConfig === '2' ? _vm.differentFirstName : false,
      "specificMessage": _vm.$t('suppliers.not_same_firstname', {
        realFirstName: _vm.databaseFirstName
      })
    },
    model: {
      value: (_vm.firstname),
      callback: function($$v) {
        _vm.firstname = $$v
      },
      expression: "firstname"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('suppliers.core_business'),
      "warningIndicator": _vm.controlsConfig === '1' ? _vm.invalidCoreBusiness : false,
      "specificErrorIndicator": _vm.controlsConfig === '2' ? _vm.invalidCoreBusiness : false,
      "specificMessage": _vm.isCoreBusinessAllowed == '1' ?
        _vm.$t('suppliers.not_same_core_business', {
          realCoreBusinessLabel: _vm.databaseCoreBusinessCode + ' - ' + _vm.databaseCoreBusinessLabel
        }) : _vm.$t('suppliers.illegal_core_business')
    },
    model: {
      value: (_vm.coreBusiness),
      callback: function($$v) {
        _vm.coreBusiness = $$v
      },
      expression: "coreBusiness"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('suppliers.legal_status'),
      "inputType": 'listeSelect',
      "warningIndicator": _vm.controlsConfig === '1' ? _vm.differentLegalStatus : false,
      "specificErrorIndicator": _vm.controlsConfig === '2' ? _vm.differentLegalStatus : false,
      "specificMessage": _vm.$t('suppliers.not_same_legal_status', {
        realLegalStatus: _vm.databaseLegalStatuslabel
      })
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.legalStatus),
      expression: "legalStatus"
    }],
    staticClass: "form-control",
    class: {
      errorBorder: _vm.differentLegalStatus && _vm.controlsConfig === '2', warningBorder: _vm.differentLegalStatus && _vm.controlsConfig === '1'
    },
    attrs: {
      "id": "sel2",
      "readonly": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.legalStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('suppliers.slct_legal_status')))]), _vm._v(" "), _vm._l((_vm.legalStatusList), function(status) {
    return _c('option', {
      key: status.code,
      domProps: {
        "value": status.code
      }
    }, [_vm._v("\n              " + _vm._s(status.label) + "\n            ")])
  })], 2)])], 1)], 1), _vm._v(" "), (_vm.LMSGsupplierconfig) ? _c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.eml_adrs'),
      "regexpErrorIndicator": _vm.emailAddressRegexpError
    },
    model: {
      value: (_vm.emailAddress),
      callback: function($$v) {
        _vm.emailAddress = $$v
      },
      expression: "emailAddress"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group mt-sm-4",
    attrs: {
      "sm": "6"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mt-sm-2",
    attrs: {
      "value": 1,
      "unchecked-value": 0
    },
    model: {
      value: (_vm.createAccount),
      callback: function($$v) {
        _vm.createAccount = $$v
      },
      expression: "createAccount"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('suppliers.moneyroad_create_account')) + "\n        ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.adrs')
    },
    model: {
      value: (_vm.address),
      callback: function($$v) {
        _vm.address = $$v
      },
      expression: "address"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.zp_code')
    },
    model: {
      value: (_vm.zipCode),
      callback: function($$v) {
        _vm.zipCode = $$v
      },
      expression: "zipCode"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.cty')
    },
    model: {
      value: (_vm.townName),
      callback: function($$v) {
        _vm.townName = $$v
      },
      expression: "townName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('template', {
    slot: "footerButtons"
  }, [_c('b-row', {
    staticClass: "form-group justify-content-start"
  }, [_c('b-col', {
    attrs: {
      "md": "3",
      "offset-md": "8"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    attrs: {
      "disabled": _vm.isCoreBusinessAllowed === '0'
    },
    on: {
      "click": _vm.createSupplier
    }
  }, [_c('i', {
    staticClass: "icon fa fa-save"
  }), _vm._v("\n          " + _vm._s(_vm.$t('suppliers.form_supplier_create_button')) + "\n        ")])], 1)], 1)], 1)], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e36612ec", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e36612ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/requests/creationPages/SupplierCreateTemplate.vue
// module id = 2454
// module chunks = 2